import { TApiErrorResult } from '../models/apiError.ts';
import { TDepositMessages } from '../models/pnpCashier.ts';
import { findDocs } from '../payload/client.ts';

const COLLECTION = 'flow_messages';

const FALLBACK_KEY = 'something_went_wrong';

const MESSAGE_FIELDS = ['key', 'title', 'message', 'btn_main_text', 'btn_secondary_text'];

type TFlowMessage = {
  key: string;
  title?: string | null;
  message?: string | null;
  btn_main_text?: string | null;
  btn_secondary_text?: string | null;
};

const findByKeys = (language: string, keys: string[]) => {
  const wanted = [...new Set(keys.filter(Boolean))].sort();

  if (!wanted.length) return Promise.resolve([]);

  return findDocs<TFlowMessage>(COLLECTION, {
    locale: language,
    limit:  wanted.length,
    select: MESSAGE_FIELDS,
    where:  { 'where[key][in]': wanted.join(',') },
  });
};

export const getApiErrors = async ({
  language,
  key,
}: {
  language: string;
  key: string;
}): Promise<TApiErrorResult> => {
  const messages = await findByKeys(language, [key, key?.toLowerCase(), FALLBACK_KEY]);

  const fallbackTitle = messages.find((m) => m.key === FALLBACK_KEY)?.title ?? undefined;

  const message = messages.find(
    (item) => item.key === key || item.key === key?.toLowerCase(),
  );

  if (!message) {
    return { content: undefined, fallbackTitle };
  }

  return {
    content: {
      title:            message.title ?? undefined,
      message:          message.message ?? undefined,
      btnMainText:      message.btn_main_text ?? undefined,
      btnSecondaryText: message.btn_secondary_text ?? undefined,
    },
    fallbackTitle,
  };
};

export const getCommonTranslations = async (
  language: string,
): Promise<{ search: string }> => {
  const [search] = await findByKeys(language, ['search']);

  return { search: search?.title ?? '' };
};

export const getDepositMessages = async (
  language: string,
): Promise<TDepositMessages> => {
  const messages = await findByKeys(language, [
    'deposit_too_low',
    'deposit_too_high',
    'deposit_required',
  ]);

  const messageFor = (key: string) => messages.find((m) => m.key === key)?.message ?? undefined;

  return {
    tooLow:   messageFor('deposit_too_low'),
    tooHigh:  messageFor('deposit_too_high'),
    required: messageFor('deposit_required'),
  };
};
